const searchIcon = document.querySelector('.header__icon--search');
const detailsEl = document.querySelector('.header__search details');

searchIcon.addEventListener('click', () => {

  const checkWizzy = setInterval(() => {
    const wizzyWrapper = document.querySelector('.wizzy-autocomplete-wrapper');

    if (wizzyWrapper) {
      clearInterval(checkWizzy);

      const observer = new MutationObserver(() => {
        if (!detailsEl.hasAttribute('open')) {
          wizzyWrapper.style.display = 'none';
        }
      });

      observer.observe(detailsEl, {
        attributes: true,
        attributeFilter: ['open']
      });
    }

  }, 50);

});



const colorMap = {
  "Pink": "#FFC0CB",
  "Blue": "#0000FF",
  "Green": "#008000",
  "Black": "#000000",
  "White": "#FFFFFF",
  "Multi-Color": "#CCCCCC",
  "Yellow": "#FFFF00",
  "Red": "#FF0000",
  "Beige": "#F5F5DC",
  "Purple": "#800080",
  "Ivory": "#FFFFF0",
  "Navy Blue": "#000080",
  "Grey": "#808080",
  "Off White": "#F8F8F0",
  "Gold": "#FFD700",
  "Brown": "#A52A2A",
  "Orange": "#FFA500",
  "Peach": "#FFE5B4",
  "Lavender": "#E6E6FA",
  "Mustard": "#FFDB58",
  "Maroon": "#800000",
  "Teal": "#008080",
  "Olive": "#808000",
  "Rust": "#B7410E",
  "Cream": "#FFFDD0",
  "Wine": "#722F37",
  "Mauve": "#E0B0FF",
  "Turquoise": "#40E0D0",
  "Silver": "#C0C0C0",
  "Coral": "#FF7F50",
  "Magenta": "#FF00FF",
  "Burgundy": "#800020",
  "Nude": "#E3BC9A",
  "Taupe": "#483C32",
  "Rose Gold": "#B76E79",
  "Aqua": "#00FFFF",
  "Tan": "#D2B48C",
  "Khaki": "#C3B091",
  "Charcoal": "#36454F",
  "Indigo": "#4B0082",
  "Bronze": "#CD7F32",
  "Metallic": "#D4D4D4",
  "Copper": "#B87333",
  "Clear": "#FFFFFF00",
  "White Gold": "#FAF5E9"
};



window.onWizzyScriptLoaded = function() {

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
        function(data) {
            if (data.api === 'search') {

            }
            return data;
        });
      window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload.response.payload.facets;
        if (facets) {
          facets.forEach((facet) => {
            if (facet.key === "colors") {
              let facet_data = facet.data;
              if (facet_data) {
                facet_data.forEach((item) => {
                  let color = colorMap[item.label] || "#000000";
                  (item.isSwatch = !0),
                    (item.isURLSwatch = false),
                    (item.isVisualSwatch = !0),
                    (item.swatchValue = color),
                    (item.data = {
                      value: item.key,
                      swatch: {
                        type: "visual",
                        value: color,
                      },
                    });
                  item.code = color;
                });
              }
            }
          });
        }
      }
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
  function (products) {
    try {
      products.forEach(function (product) {
        if (!product?.name || !product?.brand) return;

        const brandRegex = new RegExp("^" + product.brand + "\\s*", "i");
        product.productName = product.name.replace(brandRegex, "").trim();
        });
      } catch (e) {
        console.log(e);
      }

        return products;
      }
    );
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
        function(products) {
          try {
             products.forEach(function (product) {
            if (product.sellingPrice !== undefined && product.sellingPrice !== null) {
              product.sellingPrice = Math.round(
                Number(String(product.sellingPrice).replace(/,/g, ""))
              );
            }

            if (product.price !== undefined && product.price !== null) {
              product.price = Math.round(
                Number(String(product.price).replace(/,/g, ""))
              );
            }

          });

            } catch (e) {
                console.log(e);
            }
            return products;
        });
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
        function(data) {
            if(document.querySelector('.product-media-modal.media-modal')){
                document.querySelector('.product-media-modal.media-modal').style.display = 'none';
            }
            return data;
        });
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
        function(data) {
            data.filters.configs.keepOpenedInMobileAfterApply = !0;
            data.autocomplete.configs.defaultBehaviour.suggestions.enabled = true;
          data.search.configs.facets.leftFacets.mobileCollapsible = true;
          data.filters.configs.displayAsDrawer = false;
          data.common.lazyDOMConfig.searchInputIdentifiers=  [
                {
                    "dom": ".search__input.field__input",
                    "type": "search"
                }
            ]
            // try {
            //      window.wizzyConfig.search.configs.facets.configs = window.wizzyConfig.search.configs.facets.configs.filter(facet => facet.key !== "sellingPrice");
            // window.wizzyConfig.search.configs.facets.configs.push({
            //     label: "Price",
            //     buckets: [{
            //         from: 26,
            //         to: 500
            //     }, {
            //         from: 501,
            //         to: 1500
            //     }, {
            //         from: 1501,
            //         to: 3000
            //     }, {
            //         from: 3001,
            //         to: 4500
            //     }, {
            //         from: 4501,
            //         to: 6000
            //     }],
            //     key: "sellingPrice",
            //     position: "left"
            // });
            // } catch (error) {
            //     console.log("wizzy error",error);
            // }
           
   
            return data;
        },2);

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
        function(data) {
            data.filters.configs.keepOpenedInMobileAfterApply = !0;
            if(window.wizzyConfig.common.isOnCategoryPage)
            {
                window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["#MainContent"];
            }
            data.autocomplete.configs.defaultBehaviour.suggestions.enabled = true;

            //          try {
            //      window.wizzyConfig.search.configs.facets.configs = window.wizzyConfig.search.configs.facets.configs.filter(facet => facet.key !== "sellingPrice");
            // window.wizzyConfig.search.configs.facets.configs.push({
            //     label: "Price",
            //     buckets: [{
            //         from: 26,
            //         to: 500
            //     }, {
            //         from: 501,
            //         to: 1500
            //     }, {
            //         from: 1501,
            //         to: 3000
            //     }, {
            //         from: 3001,
            //         to: 4500
            //     }, {
            //         from: 4501,
            //         to: 6000
            //     }],
            //     key: "sellingPrice",
            //     position: "left"
            // });
            // } catch (error) {
            //     console.log("wizzy error",error);
            // }
        data.search.configs.facets.leftFacets.mobileCollapsible = true;
          data.common.lazyDOMConfig.searchInputIdentifiers=  [
                {
                    "dom": ".search__input.field__input",
                    "type": "search"
                }
            ]
            return data;
        },2);

        
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
        function(data) {
    //         if(window.innerWidth < 768){
    //     const sortingCaption = document.querySelector('.facet-filters.caption'); 
    //     const filterSortMobile = document.querySelector('.filter-and-sort-mobile');

    //     if (sortingCaption && filterSortMobile) {
    //     filterSortMobile.insertBefore(
    //         sortingCaption,
    //         filterSortMobile.children[1] || null
    //     );
    //     }
    // }

        const facetsCount = document.querySelector('.mobile-facets__count');
        const totalProducts = data?.data?.response?.payload?.total;

        if(facetsCount && totalProducts){
            facetsCount.textContent = totalProducts + "";
        }

            const wrapper = document.querySelector(".wizzy-search-summary-container");


            if (wrapper && wrapper.innerHTML.trim() === "") {
              const total = data?.data?.response?.payload?.total || 0;
              const query = data?.data?.response?.payload?.filters?.q || "";
              if (window.wizzyConfig.common.isOnCategoryPage) {
                wrapper.innerHTML = `
                  <p class="wizzy-summary-head">${total}  Products</p>
                `;

                const summary = document.querySelector('.wizzy-search-summary-wrapper');
                const filtersTop = document.querySelector('.search-filters-top-wrapper');

                if (summary && filtersTop) {
                  filtersTop.insertBefore(summary, filtersTop.firstChild);
                }
              }

            }


            return data;
        });



   

}